var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2488_1587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2488_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4702 9.56252H3.9375C3.77789 9.56252 3.64424 9.50868 3.53655 9.40099C3.42885 9.2933 3.375 9.15965 3.375 9.00004C3.375 8.84043 3.42885 8.70678 3.53655 8.59909C3.64424 8.4914 3.77789 8.43756 3.9375 8.43756H12.4702L8.59326 4.56062C8.48172 4.44908 8.42668 4.31856 8.42813 4.16905C8.42956 4.01952 8.48846 3.88659 8.60481 3.77025C8.72114 3.6616 8.85287 3.60535 8.99998 3.6015C9.14709 3.59765 9.27882 3.6539 9.39516 3.77025L14.1504 8.52553C14.2206 8.59572 14.2701 8.66976 14.299 8.74765C14.3278 8.82552 14.3423 8.90965 14.3423 9.00004C14.3423 9.09043 14.3278 9.17456 14.299 9.25243C14.2701 9.33032 14.2206 9.40436 14.1504 9.47455L9.39516 14.2298C9.29132 14.3337 9.16272 14.3868 9.00936 14.3892C8.85599 14.3916 8.72114 14.3385 8.60481 14.2298C8.48846 14.1135 8.43028 13.9798 8.43028 13.8289C8.43028 13.6779 8.48846 13.5443 8.60481 13.4279L12.4702 9.56252Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow_next.f144d732c24dce34835128e8f402ccdf.svg";
export { ForwardRef as ReactComponent };